import { NavLink, Outlet } from "react-router-dom"
import clsx from "clsx"
import GuardianIcon from "@/components/common/GuardianIcon"
import PlayerAvatar from "@/components/player/PlayerAvatar"
import { GuardianIconName } from "@/constants/guardianIconNames"
import HotelRestBanner from "@/components/HotelRestBanner"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"

const tabs: {
  to: string
  end?: boolean
  label: string
  icon: GuardianIconName | "profile"
}[] = [
  { to: "/play", end: true, label: "Бой", icon: "fight" },
  { to: "/play/map", label: "Карта", icon: "map" },
  { to: "/play/collection", label: "Колода", icon: "cards" },
  { to: "/play/profile", label: "Профиль", icon: "profile" },
]

export default function PlayLayout() {
  const { passport } = useGuardiansPassport()

  return (
    <div className="flex min-h-dvh flex-col bg-guardians-bg">
      <HotelRestBanner />
      <main className="flex-1 overflow-auto pb-[4.5rem]">
        <Outlet />
      </main>
      <nav className="fixed bottom-0 left-1/2 z-40 w-full max-w-app -translate-x-1/2 border-t border-white/10 bg-guardians-bg/95 backdrop-blur">
        <ul className="flex justify-around px-2 py-2">
          {tabs.map(({ to, label, icon, end }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={end ?? false}
                className={({ isActive }) =>
                  clsx(
                    "flex flex-col items-center gap-0.5 px-3 py-1 text-xs",
                    isActive ? "text-guardians-accent" : "text-guardians-muted"
                  )
                }
              >
                {icon === "profile" ? (
                  passport ? (
                    <PlayerAvatar
                      element={passport.affiliationElement}
                      avatarVariant={passport.avatarVariant}
                      nickname={passport.nickname}
                      academicLeague={passport.academicLeague}
                      profileFrameKey={passport.profileFrameKey}
                      guardianRank={
                        passport.guardianRankInfo?.rank ??
                        passport.activeTime?.guardianRank ??
                        null
                      }
                      size="xs"
                    />
                  ) : (
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/15 text-[10px] font-bold">
                      ?
                    </span>
                  )
                ) : (
                  <GuardianIcon name={icon} size={26} />
                )}
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}
